import DeleteConfirmDialog from '@/components/ui/dialog/delete-confirm-dialog';
type DialogText = { title: string; description: string };
export type DialogCategory = 'read' | 'cancelled' | 'done';

const MESSAGES: Record<DialogCategory, DialogText> = {
  read: {
    title: 'Delete all READ notifications?',
    description:
      'This action cannot be undone. All READ notifications will be permanently deleted from your inbox.',
  },
  cancelled: {
    title: 'Delete all notifications for CANCELLED DEALS?',
    description:
      'This action cannot be undone. All notifications related to CANCELLED DEALS will be permanently deleted from your inbox.',
  },
  done: {
    title: 'Delete all notifications for DONE DEALS?',
    description:
      'This action cannot be undone. All notifications related to DONE DEALS will be permanently deleted from your inbox.',
  },
};

export function BulkDeleteDialog({
  open,
  onOpenChange,
  category,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  category: DialogCategory;
  onConfirm: () => void;
}) {
  const { title, description } = MESSAGES[category];

  return (
    <DeleteConfirmDialog
      title={title}
      description={description}
      onConfirm={onConfirm}
      dialogIsOpen={open}
      onOpen={() => onOpenChange(true)}
      onClose={() => onOpenChange(false)}
    />
  );
}
